/** @typedef {'phone-expanded' | 'phone-collapsed' | 'default' | 'minimized' | 'expanded'} LeftNavigationState */
// TODO: sync this with left navigation to avoid hardcoding values
const NAV_OFFSET_PX = {
  default: 260,
  expanded: 260,
  minimized: 88,
  'phone-expanded': 320,
  'phone-collapsed': 0,
}

/**
 * @param {LeftNavigationState | string | undefined} leftNavigationState
 * @returns {number}
 */
function getNavOffsetPxForRail(leftNavigationState) {
  if (leftNavigationState != null && NAV_OFFSET_PX[leftNavigationState] !== undefined) {
    return NAV_OFFSET_PX[leftNavigationState]
  }
  return NAV_OFFSET_PX.default
}

/**
 * Pane-state flag for expanded rail width (may deserialize as string from URL query).
 * @param {unknown} value
 * @returns {boolean}
 */
export function isTruthyRailExpanded(value) {
  return value === true || value === 'true'
}

/**
 * Effective CSS width for the right rail (desktop expanded vs route default; phone uses full viewport).
 *
 * @param {Object} options
 * @param {string} [options.routeWidth]
 * @param {Record<string, unknown>} [options.paneProps]
 * @param {boolean} options.isPhone
 * @param {LeftNavigationState | string | undefined} options.leftNavigationState
 * @returns {string}
 */
export function getEffectiveRailWidth({
  routeWidth,
  paneProps,
  isPhone,
  leftNavigationState,
}) {
  const railExpanded = isTruthyRailExpanded(paneProps?.railExpanded)
  const baseWidth = routeWidth || '440px'

  if (isPhone) {
    return '100vw'
  }

  if (railExpanded) {
    const offsetPx = getNavOffsetPxForRail(leftNavigationState)
    return `calc(100vw - ${offsetPx}px)`
  }

  return baseWidth
}
